import { ConversationTestActions } from './ConversationTestActions.mjs';
import { setRuleEvaluatorAnswers } from '../../../utils';
import { extractAnswersFromPageResponse } from '../../../state';

const conversationTestReducer = (state, action) => {
  switch (action.type) {
    case ConversationTestActions.CONV_TEST_REQUEST_STARTED: {
      return {
        ...state,
        testPageIsLoading: true,
      };
    }

    case ConversationTestActions.CONV_TEST__REQUEST_SUCCESSFUL: {
      const answersResponse = extractAnswersFromPageResponse(action.data);
      const answers = {
        ...state?.answers,
        ...answersResponse,
      };
      setRuleEvaluatorAnswers(answers);

      return {
        ...state,
        testPageData: action.data,
        answers,
        testPageIsLoading: false,
      };
    }

    case ConversationTestActions.CONV_TEST_REQUEST_FAILED: {
      return {
        ...state,
        testPageIsLoading: false,
      };
    }

    default:
      return state;
  }
};

export default conversationTestReducer;
